import React from "react"
import { useSelector } from "react-redux"

import { ACTIVE, INACTIVE } from "const"
import { StoreType, PackageFilters } from "client/store"
import { ActiveInactive } from "client/utils"
import {
    SearchBar,
    SearchFilter,
} from "client/components"

interface SearchPackage {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: PackageFilters
    onFilter: (filters: PackageFilters) => void
}

const statusArray = [ACTIVE, INACTIVE]

const PackageSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchPackage) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const popupFilters: SearchFilter[] = []

    statusArray.forEach((status: ActiveInactive) => {
        popupFilters.push({
            title: lang[status],
            isActive: filters.status === status,
            onAdd: (obj: PackageFilters) => ({
                ...obj,
                status,
            }),
            onClose: (obj: PackageFilters) => ({
                ...obj,
                status: null,
            }),
        })
    })

    return (
        <SearchBar
            id={id}
            filters={filters}
            leftOffset={leftOffset}
            rightOffset={rightOffset}
            popupFilters={popupFilters}
            onFilter={onFilter}
        />
    )
}
export default PackageSearch
